import React from "react";
import ClaimButton from "@components/FlowActionButtons/ClaimButton";
import { canUserClaim, type DeficiencyFlowData } from "./utils";

interface ClaimDeficiencyProps {
  deficiencyFlowData?: DeficiencyFlowData;
  onClaim?: () => void;
}

const LANG_BASE = "deficiencies";

const ClaimDeficiency: React.FC<ClaimDeficiencyProps> = ({
  deficiencyFlowData,
  onClaim = () => {},
}) => {
  if (!deficiencyFlowData?.task) {
    return null;
  }

  const isActionAvailable = canUserClaim(deficiencyFlowData.task.status, deficiencyFlowData.status);

  return (
    <ClaimButton
      langBase={LANG_BASE}
      permission="canClaimFottDeficiency"
      isActionAvailable={isActionAvailable}
      onClaim={onClaim}
    />
  );
};

export default ClaimDeficiency;
